import { ComparisonOperators } from '@contentsquare/fov-constants';
export const carrierCondition = {
    id: 'carrier',
    category: 'conditions',
    value: {
        operatorValues: [{ value: ComparisonOperators.MATCH_IN }, { value: ComparisonOperators.DOES_NOT_MATCH_IN }],
        choiceValues: [
            { value: 'sfr', label: 'SFR' },
            { value: '3 ITA', label: '3 ITA' },
            { value: 'AT&T', label: 'AT&T' },
            { value: 'AT&T 4G', label: 'AT&T 4G' },
            { value: 'Bouygues Telecom', label: 'Bouygues Telecom' },
            { value: 'Credit Mutuel', label: 'Credit Mutuel' },
            { value: 'F Bouygues', label: 'F Bouygues' },
            { value: 'F SFR', label: 'F SFR' },
            { value: 'F-Bouygues Telecom', label: 'F-Bouygues Telecom' },
            { value: 'Free', label: 'Free' },
            { value: 'I TIM', label: 'I TIM' },
            { value: 'I WIND', label: 'I WIND' },
            { value: 'La Poste Mobile', label: 'La Poste Mobile' },
            { value: 'Movistar', label: 'Movistar' },
            { value: 'Orange', label: 'Orange' },
            { value: 'Orange B', label: 'Orange B' },
            { value: 'Orange F', label: 'Orange F' },
            { value: 'SFR altice', label: 'SFR altice' },
            { value: 'TELCEL', label: 'TELCEL' },
            { value: 'vodafone IT', label: 'vodafone IT' },
            { value: 'vodafone P', label: 'vodafone P' },
        ],
    },
};
//# sourceMappingURL=carrier-condition.value.js.map